import { CreateRequest } from 'firebase-admin/auth'

import { Candidate } from '@/interfaces/candidate'
import {
  ApplyToOpenVacancyApiResponse,
  CreateUserAccountApiResponse,
  RequestMethod,
} from '@/interfaces/http'
import fetchData from '@/lib/http/request'
import { API_ENDPOINTS } from './config'
import { AvailabilityRequestPayload } from '@/interfaces/availability'
import {
  OtysVacancyDetailsListResponse,
  VacanciesReqBody,
} from '@/interfaces/vacancy'

export const createUserAccount = (payload: CreateRequest, idToken: string) => {
  type DataType = {
    email: string
    firstName: string
    phoneNumber: string
    candidateId: string
  }

  try {
    const user: Promise<DataType> = fetchData({
      url: API_ENDPOINTS.USER.CREATE,
      data: payload,
      method: RequestMethod.POST,
      idToken,
    })

    return user
  } catch (error) {
    console.error('Create User Account', error)
  }
}

export const sendApplyToVacancyViaRayRequest = async (
  payload: FormData,
  idToken: string
) => {
  await fetchData({
    url: API_ENDPOINTS.VACANCY.APPLY.RAY,
    method: RequestMethod.POST,
    data: payload,
    idToken,
  })
}

export const sendApplyToVacancyRequest = async (
  payload: FormData
): Promise<ApplyToOpenVacancyApiResponse> => {
  const data = await fetchData<ApplyToOpenVacancyApiResponse, FormData>({
    url: API_ENDPOINTS.VACANCY.APPLY.RVDB,
    method: RequestMethod.POST,
    data: payload,
  })

  return data
}

export const sendUpdateProfileRequest = async (
  payload: Candidate,
  cid: string,
  idToken: string
) => {
  const data = await fetchData({
    url: API_ENDPOINTS.PROFILE.UPDATE,
    method: RequestMethod.POST,
    data: payload,
    idToken,
  })

  return data
}

export const sendUploadFilesRequest = async (
  payload: FormData,
  idToken: string
) => {
  const data = await fetchData({
    url: API_ENDPOINTS.FILES.UPLOAD,
    method: RequestMethod.POST,
    data: payload,
    idToken,
  })

  return data
}

export const sendUploadPictureRequest = async (
  payload: FormData,
  cid: string,
  idToken: string
) => {
  const data = await fetchData({
    url: API_ENDPOINTS.PICTURE.UPLOAD,
    method: RequestMethod.POST,
    data: payload,
    idToken,
  })

  return data
}

export const sendRegisterUserRequest = async (
  payload: FormData
): Promise<CreateUserAccountApiResponse> => {
  const data = await fetchData<CreateUserAccountApiResponse, FormData>({
    url: API_ENDPOINTS.ACCOUNT.CREATE,
    method: RequestMethod.POST,
    data: payload,
  })

  return data
}

export const sendUpdateAvailabilityRequest = async (
  payload: AvailabilityRequestPayload,
  cid: string,
  idToken: string
) => {
  const data = await fetchData({
    url: API_ENDPOINTS.AVAILABILITY.UPDATE,
    method: RequestMethod.POST,
    data: payload,
    idToken,
  })

  return data
}

export const sendListVacanciesRequest = async ({
  data,
  idToken,
}: {
  data: Partial<VacanciesReqBody>
  idToken: string
}) => {
  const result = await fetchData<
    OtysVacancyDetailsListResponse,
    Partial<VacanciesReqBody>
  >({
    url: API_ENDPOINTS.VACANCY.LIST,
    method: RequestMethod.POST,
    idToken,
    data,
  })

  return result
}

export const sendListFilesRequest = async (idToken: string) => {
  const data = await fetchData({
    url: API_ENDPOINTS.FILES.LIST,
    method: RequestMethod.GET,
    idToken,
  })

  return data
}

export const sendDeleteFileRequest = async ({
  fileUid,
  idToken,
}: {
  fileUid: string
  idToken: string
}) => {
  const data = await fetchData({
    url: API_ENDPOINTS.FILES.DELETE(fileUid),
    method: RequestMethod.POST,
    idToken,
  })

  return data
}

export const sendGetCandidateRequest = async ({
  idToken,
}: {
  idToken: string
}) => {
  const result = await fetchData({
    url: API_ENDPOINTS.CANDIDATE.GET,
    method: RequestMethod.GET,
    idToken,
  })

  return result
}
